import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
};

export const ReportDataSlice = createSlice({
  name: 'ReportData',
  initialState,
  reducers: {
    setReportPayload: (state, action) => {
      state.data = action.payload;
    },
    clearReportPayload: (state) => {
      state.data = null;
    }
  },
});

export const { setReportPayload, clearReportPayload } = ReportDataSlice.actions;

export default ReportDataSlice.reducer;
